import { observable, runInAction } from 'mobx';

// The people whose card the user closed, per chat. It lives in memory only, so a restart brings the cards back.
const dismissedPeople = observable.set<string>();

const dismissalKey = (draftId: string, personId: string) =>
  `${draftId}:${personId}`;

export const isCardDismissed = (draftId: string, personId: string): boolean =>
  dismissedPeople.has(dismissalKey(draftId, personId));

export const dismissCard = (draftId: string, personIds: string[]) =>
  runInAction(() => {
    personIds.forEach((personId) =>
      dismissedPeople.add(dismissalKey(draftId, personId))
    );
  });
